<script lang="ts">
	import type { AdId } from '$lib/services/advertising/types';
	import { page } from '$app/state';
	import GoogleAd from '$lib/components/advertising/GoogleAd.svelte';
	import { type AdFormats } from '$lib/services/advertising';
	import { getReworldAdUnit } from '$lib/services/advertising/reworld';
	import { getReworldDivId, getReworldTargeting } from '$lib/services/advertising/reworld/ids';
	import { onMount } from 'svelte';

	interface Props {
		adFormat: AdFormats;
		adId: AdId;
		showAdByDefault: boolean;
		adIdForTests: AdId;
		onAdAvailabilityChange?: (isAvailable: boolean) => void;
	}

	const {
		adFormat,
		adId,
		showAdByDefault,
		adIdForTests,
		onAdAvailabilityChange,
	}: Props = $props();

	const adUnit = $derived(getReworldAdUnit(page.data.locale));

	onMount(() => {
		window.reworldAd?.que.push(() => {
			window.reworldAd?.refresh?.();
		});
	});
</script>

<GoogleAd
	{adFormat}
	{adIdForTests}
	adId={getReworldDivId(adId)}
	{adUnit}
	{showAdByDefault}
	targetings={getReworldTargeting(adId)}
	{onAdAvailabilityChange}
/>
